import { IonImg } from "@ionic/react";
import logo from "@variants/app-logo.png";

interface AppLogoProps {
  className?: string;
  alt?: string;
}

const AppLogo: React.FC<AppLogoProps> = ({
  className = "tw:block tw:mx-auto tw:max-w-[100px]",
  alt = "App Logo",
}) => {
  return <IonImg src={logo} alt={alt} className={className} />;
};

export default AppLogo;
